import { api } from '../../api'
import { Mgmt } from '../../types'

interface GetMgmtsResponse {
  mgmts: Mgmt[]
}
const base = '/mgmt'

export const getMgmts = async (params?: { description?: string }) => {
  const response = await api.get<GetMgmtsResponse>(base, {
    params,
  })

  return response.data.mgmts
}
